/* Barlen: het gedeelde gedrag van de eigen zijpanelen, voor elk aside.m6pn met data-barlen-zijpaneel.
   Openen en sluiten doet het thema zelf (openPanel en hidePanels; a[data-panel="<id>"] opent, de sluitknop, Escape en
   de donkere laag sluiten). Dit script vult aan:
   a. het paneel verhuist naar #root, naast de panelen van het thema; binnen de pagina zou het onder de donkere laag
      vallen;
   b. na het sluiten gaat de focus terug naar de link die het paneel opende, ook na een muisklik;
   c. Tab blijft binnen het open paneel;
   d. een tik vóórdat het paneelscript van het thema er is: eerst dat script ophalen en dan het paneel openen, in plaats
      van de link naar de pagina te volgen;
   e. de terugknop van de browser of telefoon sluit het paneel:
      - bij openen één item in de geschiedenis: hetzelfde adres, met een merkteken voor dit paneel in de state;
      - terug terwijl het paneel open is: het paneel sluit en de bezoeker blijft op de pagina;
      - sluiten met het kruisje, Escape of de donkere laag terwijl ons item bovenaan staat: één keer history.back(),
        zodat de volgende stap terug meteen naar de vorige pagina gaat; een vlag voorkomt een lus;
      - een link in het open paneel naar een andere pagina (in hetzelfde tabblad) vervangt ons item
        (location.replace), zodat terug vanaf die pagina in één stap op de productpagina uitkomt;
      - vooruit naar ons item: het paneel gaat weer open;
      - bij het laden: staat ons merkteken in de state maar is het paneel dicht (bijvoorbeeld na herladen), dan gaat
        het merkteken weg.
      Of ons item bovenaan staat, houdt dit script zelf bij: de keuzes op de productpagina vervangen de state
      (history.replaceState), dus het merkteken alleen is niet genoeg.
   f. de winkelwagen (#cart) is ook zo'n paneel. Hij wordt geopend via de winkelwagen van het thema (ajaxCart.open), die
      de inhoud eerst ophaalt. Komt de bezoeker terug op een item waarin de winkelwagen open stond (terug vanuit de
      kassa, of herladen), dan gaat hij weer open. Een venster binnen het paneel (aria-modal) regelt zelf de Tab-toets.
      Een link met aria-hidden="true" houdt tabindex="-1".
   Eén keer laden; de vlag voorkomt dat het twee keer start. */
(function () {
  'use strict';
  if (window.bcZijpaneel) return;
  window.bcZijpaneel = true;

  var MERK = 'barlenZijpaneel';
  var FOCUSBAAR = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea';
  var gekoppeld = typeof WeakSet === 'function' ? new WeakSet() : null;

  function eigen(id) {
    var el = id ? document.getElementById(id) : null;
    return el && el.hasAttribute('data-barlen-zijpaneel') ? el : null;
  }
  function panelen() { return Array.prototype.slice.call(document.querySelectorAll('aside.m6pn[data-barlen-zijpaneel][id]')); }
  function isOpen(el) { return !!el && el.classList.contains('toggle'); }
  function openPaneel() { return panelen().filter(isOpen)[0] || null; }
  function zichtbaar(el) { return el.getClientRects().length > 0; }
  /* De link naar een van onze panelen waarin (of waarop) geklikt is. */
  function linkNaar(doel) {
    var a = doel && doel.closest ? doel.closest('a[data-panel]') : null;
    return a && eigen(a.getAttribute('data-panel')) ? a : null;
  }
  /* Een paneel openen. De winkelwagen via de winkelwagen van het thema: die haalt de inhoud op als die er nog niet is. */
  function toon(id) {
    var wagen = window.ajaxCart;
    if (id === 'cart' && wagen && typeof wagen.open === 'function') return Promise.resolve(wagen.open({ redirect: false }));
    if (typeof window.openPanel === 'function') window.openPanel(id);
    return Promise.resolve(isOpen(eigen(id)));
  }

  /* ---------- d. een tik vóórdat het paneelscript van het thema er is */
  document.addEventListener('click', function (e) {
    if (typeof window.openPanel === 'function' || e.defaultPrevented) return;
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = linkNaar(e.target);
    var thema = window.XclusiveTheme;
    if (!a || !thema || typeof thema.ensureCustomAsyncRuntime !== 'function') return;
    e.preventDefault();
    var id = a.getAttribute('data-panel');
    var naarPagina = function () { window.location.href = a.href; };
    thema.ensureCustomAsyncRuntime().then(function () {
      if (typeof window.openPanel === 'function') toon(id); else naarPagina();
    }).catch(naarPagina);
  }, true);

  /* ---------- b. welke link opende het paneel */
  var bron = {};
  function onthoud(e) {
    var a = linkNaar(e.target);
    if (a) bron[a.getAttribute('data-panel')] = a;
  }
  document.addEventListener('click', onthoud, true);
  document.addEventListener('keyup', onthoud, true);

  function focusTerug(el) {
    var terug = bron[el.id];
    setTimeout(function () {
      var actief = document.activeElement;
      /* Het thema zet de focus op de eerste link naar dit paneel; ging het open vanaf een andere link, dan daarheen.
         Na een klik op de donkere laag ligt de focus op die laag (een link van het thema); ook dan terug. */
      var andereLink = !!(actief && actief !== terug && actief.matches && actief.matches('a[data-panel="' + el.id + '"], a.overlay-close, a.overlay-close-clipping, #root > a.m6pn-close'));
      if (terug && terug.isConnected && (!actief || actief === document.body || el.contains(actief) || andereLink)) {
        try { terug.focus({ preventScroll: true }); } catch (x) { terug.focus(); }
      }
    }, 150);
  }

  /* ---------- c. Tab en Shift+Tab blijven binnen het open paneel, ook als de focus er even buiten lag */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var el = openPaneel();
    if (!el) return;
    if (el.querySelector('[aria-modal="true"]')) return; /* een venster in het paneel houdt de focus zelf vast */
    var items = Array.prototype.filter.call(el.querySelectorAll(FOCUSBAAR), zichtbaar);
    if (!items.length) { e.preventDefault(); return; }
    var eerste = items[0];
    var laatste = items[items.length - 1];
    var actief = document.activeElement;
    if (!el.contains(actief)) { e.preventDefault(); (e.shiftKey ? laatste : eerste).focus(); return; }
    if (e.shiftKey && actief === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && actief === laatste) { e.preventDefault(); eerste.focus(); }
  }, true);

  /* ---------- e. de terugknop */
  var boven = null;        /* id van het paneel waarvan ons item nu bovenaan de geschiedenis staat */
  var terugBezig = false;  /* wij riepen history.back() aan en wachten op popstate */
  var terugKlok = null;
  var wachtOpItem = null;  /* paneel dat openging terwijl ons history.back() nog liep */

  function stateMet(id) {
    var s = history.state;
    var uit = {};
    if (s && typeof s === 'object') Object.keys(s).forEach(function (k) { uit[k] = s[k]; });
    uit[MERK] = id;
    return uit;
  }
  function stateZonder(s) {
    var uit = {};
    var leeg = true;
    Object.keys(s).forEach(function (k) { if (k !== MERK) { uit[k] = s[k]; leeg = false; } });
    return leeg ? null : uit;
  }
  function nieuwItem(id) {
    try { history.pushState(stateMet(id), '', window.location.href); boven = id; } catch (x) { boven = null; }
  }

  function bijOpen(el) {
    if (boven === el.id) return; /* al een item (vooruit naar ons item) */
    if (terugBezig) { wachtOpItem = el.id; return; }
    nieuwItem(el.id);
  }
  function bijSluiten(el) {
    if (wachtOpItem === el.id) wachtOpItem = null;
    if (boven !== el.id) return; /* gesloten door terug, of er was geen item */
    boven = null;
    terugBezig = true;
    clearTimeout(terugKlok);
    terugKlok = setTimeout(function () { terugBezig = false; }, 1500);
    try { history.back(); } catch (x) { terugBezig = false; }
  }

  window.addEventListener('popstate', function (e) {
    if (terugBezig) {
      /* Het gevolg van ons eigen history.back(): niets meer doen. */
      terugBezig = false;
      clearTimeout(terugKlok);
      var w = wachtOpItem;
      wachtOpItem = null;
      if (w && isOpen(eigen(w))) nieuwItem(w);
      return;
    }
    var open = openPaneel();
    if (open) {
      /* Terug (of vooruit) terwijl een paneel open is: sluiten, de bezoeker blijft op de pagina. */
      boven = null;
      if (typeof window.hidePanels === 'function') window.hidePanels();
      return;
    }
    var s = e.state;
    var id = s && typeof s === 'object' ? s[MERK] : null;
    if (id && eigen(id) && typeof window.openPanel === 'function') {
      boven = id;
      try { toon(id); } catch (x) { /* dan blijft het dicht */ }
      if (!isOpen(eigen(id)) && id !== 'cart') boven = null;
    }
  });

  /* Terug uit de bfcache van de browser met een open paneel waarvan ons item er niet meer is (het werd vervangen door
     een link in het paneel): sluiten, zodat open paneel en geschiedenis weer bij elkaar passen. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var open = openPaneel();
    if (open && boven !== open.id && typeof window.hidePanels === 'function') window.hidePanels();
  });

  /* Een link in het open paneel naar een andere pagina: ons item vervangen in plaats van er een bij te zetten. */
  function linkInPaneel(e) {
    var el = e.currentTarget;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!isOpen(el) || boven !== el.id) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !el.contains(a) || a.classList.contains('m6pn-close') || a.hasAttribute('data-panel') || a.hasAttribute('download')) return;
    var venster = (a.getAttribute('target') || '').toLowerCase();
    if (venster && venster !== '_self') return;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (x) { return; }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return; /* mailto: en tel: verlaten de pagina niet */
    var hier = window.location;
    if (url.origin === hier.origin && url.pathname === hier.pathname && url.search === hier.search) return; /* anker op deze pagina */
    e.preventDefault();
    boven = null;
    window.location.replace(url.href);
  }

  /* ---------- a. per paneel: verhuizen, open/dicht volgen, tabindex herstellen */
  function koppel(el) {
    if (gekoppeld ? gekoppeld.has(el) : el.bcZijpaneel) return;
    if (gekoppeld) gekoppeld.add(el); else el.bcZijpaneel = true;
    var root = document.getElementById('root');
    if (root && el.parentNode !== root) {
      /* In de thema-editor wordt de sectie opnieuw geladen; een eerder verhuisd paneel met dezelfde id gaat dan weg. */
      Array.prototype.forEach.call(root.querySelectorAll(':scope > aside[data-barlen-zijpaneel]'), function (oud) {
        if (oud !== el && oud.id === el.id) oud.remove();
      });
      root.appendChild(el);
    }
    var open = isOpen(el);
    new MutationObserver(function () {
      var nu = isOpen(el);
      if (nu === open) return;
      open = nu;
      if (open) { bijOpen(el); return; }
      bijSluiten(el);
      focusTerug(el);
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
    /* Zolang het paneel open is, blijft alles erin bereikbaar met Tab. Alleen voor wat het thema zelf aan- en uitzet
       (links, knoppen en velden); een link met aria-hidden="true" blijft buiten de Tab-volgorde, en eigen tabindex van
       andere elementen (zoals de dagen van een kalender) blijft zoals hij is. */
    new MutationObserver(function (lijst) {
      if (!isOpen(el)) return;
      lijst.forEach(function (m) {
        var t = m.target;
        if (t === el || t.getAttribute('tabindex') !== '-1') return;
        if (!t.matches || !t.matches('a, input, button, select, textarea, [role="button"]')) return;
        if (t.getAttribute('aria-hidden') === 'true') return;
        t.removeAttribute('tabindex');
      });
    }).observe(el, { subtree: true, attributes: true, attributeFilter: ['tabindex'] });
    el.addEventListener('click', linkInPaneel);
  }

  function merkWeg() {
    try {
      var s = history.state;
      if (s && typeof s === 'object' && s[MERK]) history.replaceState(stateZonder(s), '', window.location.href);
    } catch (x) { /* niets */ }
  }
  /* Terug op een item waarin de winkelwagen open stond: weer openen. Lukt dat niet, dan gaat het merkteken weg. Het
     script van het thema kan nog onderweg zijn (dit script kan eerder laden): dan wachten tot de pagina geladen is. */
  var wagenBezig = false;
  function wagenTerug() {
    if (wagenBezig) return;
    var thema = window.XclusiveTheme;
    if (!thema || typeof thema.ensureCustomAsyncRuntime !== 'function') {
      if (document.readyState !== 'complete') {
        document.addEventListener('DOMContentLoaded', wagenTerug, { once: true });
        window.addEventListener('load', wagenTerug, { once: true });
      } else merkWeg();
      return;
    }
    wagenBezig = true;
    boven = 'cart';
    thema.ensureCustomAsyncRuntime().then(function () { return toon('cart'); }).then(function (open) {
      if (!open && !isOpen(eigen('cart'))) { boven = null; merkWeg(); }
    }).catch(function () { boven = null; merkWeg(); });
  }

  function start() {
    panelen().forEach(koppel);
    /* Ons merkteken in de state terwijl er geen paneel open is (na herladen of terug vanuit de kassa): bij de
       winkelwagen weer openen, bij de andere panelen weghalen. */
    try {
      var s = history.state;
      if (s && typeof s === 'object' && s[MERK] && !openPaneel()) {
        if (s[MERK] === 'cart' && eigen('cart')) wagenTerug();
        else merkWeg();
      }
    } catch (x) { /* niets */ }
  }
  document.addEventListener('shopify:section:load', function () { panelen().forEach(koppel); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
